import { render, staticRenderFns } from "./CreatePt.vue?vue&type=template&id=60fa776a&scoped=true"
import script from "./CreatePt.vue?vue&type=script&lang=js"
export * from "./CreatePt.vue?vue&type=script&lang=js"
import style0 from "./CreatePt.vue?vue&type=style&index=0&id=60fa776a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fa776a",
  null
  
)

export default component.exports